<template>
  <div>
    <p class="text-center mb-3 mt-4">Legend</p>
    <v-divider />
    <v-row no-gutters class="my-5">
      <v-col class="text-center" v-for="(item, idx) in items" :key="idx">
        <v-chip :color="item.color">{{ item.text }}</v-chip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'AnchorChecklistLegend',
  props: {
    items: Array,
  },
};
</script>
